import React from 'react';
import {Link} from 'react-router-dom';

const Purshase = () => {
  return (
    <div>
      <div className="section my-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="box_buy_wrapper relative mb-20">
                <img className="sh_buy" src="img/icons/sh_4.png" alt="..." />
                <div className="box_buy_wrapper2">
                  <div className="box box_buy">
                    <div className="row">
                      <div className="col-lg-4">
                        <div
                          className="d-flex align-items-center
                                  text-center
                                  flex-column space-y-10">
                          <p>One Certificate Cost Just..</p>
                          <h1>Rs.1</h1>
                          <Link
                            to="upload-type"
                            className="btn btn-primary btn-lg
                                      btn_buy">
                            Issue now
                          </Link>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="col-lg-6">
                            <ul className="list_buy space-y-10">
                              <li>Send to Multiple Reciepients in Single Click</li>
                              <li>LifeTime Validity</li>
                              <li>Certificates in form of NFT</li>
                              <li>Beautifull Profile View</li>
                            </ul>
                          </div>
                          <div className="col-lg-6">
                            <ul className="list_buy space-y-10">
                              <li>Recipient Registration Not Required</li>
                              <li>No web3 Wallet requried for users</li>
                              <li>Integrate with your platforms</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="box box_buy border-0 hire_box text-center
              space-y-20">
                <h3> Need to Integrate With your Applications!</h3>
                <p>if you want someone to help you with your project</p>
                <Link to="mailto:mbcse50@gmail.com" className="btn btn-primary">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="box_buy_wrapper" />
    </div>
  );
};

export default Purshase;
